export default __webpack_public_path__ + "static/mail-merge-a8829cfe9d227ad71c6af3c3763b6017.jpg";